import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "cabinets",
  id: "wrapper-cabinets-list"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "В виджете facility-abstract выберите адрес, строение или помещение", -1)
const _hoisted_4 = [
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComponent = _resolveComponent("TableComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.cabinetsList?.data.length && !_ctx.rerender)
      ? (_openBlock(), _createBlock(_component_TableComponent, {
          key: 0,
          data: _ctx.cabinetsList.data,
          structure: _ctx.cabinetsList.structure
        }, null, 8, ["data", "structure"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
  ]))
}